import { EquipmentDocument } from '../Equipment/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SupplyItemDocument } from '../SupplyItem/queryBuilder';
import { SupplyDocument, supplyPullQueryBuilder, supplyPushQueryBuilder } from './queryBuilder';

export function suppliesFamilyMember(
  configBuilder: ConfigBuilder,
  equipment: FamilyMember<EquipmentDocument>,
  supplyItems: FamilyMember<SupplyItemDocument>,
): FamilyMember<SupplyDocument> {
  const syncConfig = configBuilder<SupplyDocument>(RxdbCollectionNameV2.SUPPLIES);
  doNotAutoSync(syncConfig);

  pull(syncConfig, supplyPullQueryBuilder);
  push(syncConfig, supplyPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy sets syncInterval to LiveInterval.SECONDS_60.
  return create(RxdbCollectionNameV2.SUPPLIES, replicationState, [equipment, supplyItems]);
}
